import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box, Column, ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { ClientDetailsForm } from '~/components/ClientDetailsForm/ClientDetailsForm';
import { useUpdateClient } from '~/hooks/reactQuery/queries/useClientMutations';
import { useLocaleKeys } from '~/i18n';
import { CLIENT_DETAILS_FORM_TEST_ID, editClientModalTextsPath, GetEditClientModalTID } from './EditClientModal.utils';
const UPDATE_CLIENT_SUCCESS_TOAST_TEST_ID = 'edit-client-success-toast';
export function EditClientModal(param) {
    let { clientId, initialName, initialClientType, dismissModal, testId } = param;
    const { t } = useLocaleKeys(editClientModalTextsPath);
    const { EditClientModalTestIds } = useMemo(()=>GetEditClientModalTID(testId), [
        testId
    ]);
    const { updateClient } = useUpdateClient();
    const { showSuccessToast } = useOverlayContext();
    const [hasError, setHasError] = useState(false);
    const methods = useForm({
        mode: 'all',
        // WHY: legacy clients predate clientType and arrive empty; default to business until ANCR-844 Phase 2 backfills it, then tighten to required.
        defaultValues: {
            clientType: initialClientType !== null && initialClientType !== void 0 ? initialClientType : 'business',
            name: initialName
        }
    });
    const onValid = async (param)=>{
        let { name, clientType } = param;
        setHasError(false);
        try {
            await updateClient({
                clientId,
                name,
                clientType
            });
        } catch (unused) {
            setHasError(true);
            return;
        }
        showSuccessToast(t.clientUpdated(), UPDATE_CLIENT_SUCCESS_TOAST_TEST_ID);
        dismissModal();
    };
    const modalProps = {
        title: t.title(),
        primaryButtonLabel: t.saveButton(),
        secondaryButtonLabel: t.cancelButton()
    };
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, methods), {
        children: /*#__PURE__*/ _jsx(ConfirmationModal, _object_spread_props(_object_spread({}, modalProps), {
            testId: EditClientModalTestIds.Root(),
            textAlignCenter: false,
            bi: {
                primaryButton: {
                    name: 'edit_client_submit'
                },
                secondaryButton: {
                    name: 'edit_client_cancel'
                },
                closeButton: {
                    name: 'edit_client_close'
                }
            },
            primaryButtonTestId: EditClientModalTestIds.SaveButton(),
            secondaryButtonTestId: EditClientModalTestIds.CancelButton(),
            onPrimaryButtonClick: methods.handleSubmit(onValid),
            onSecondaryButtonClick: dismissModal,
            onCloseButtonClick: dismissModal,
            content: /*#__PURE__*/ _jsxs(Column, {
                gap: 24,
                children: [
                    /*#__PURE__*/ _jsx(ClientDetailsForm, {
                        testId: CLIENT_DETAILS_FORM_TEST_ID
                    }),
                    hasError && /*#__PURE__*/ _jsx(Box, {
                        testId: EditClientModalTestIds.UpdateClientError(),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph2",
                            skin: "error",
                            children: t.updateClientError()
                        })
                    })
                ]
            })
        }))
    }));
}
